import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    width: '100%',
    height: '75vh',
    padding: '1rem'
  }
}));
